import React, { Component, HTMLAttributes } from "react";
import { InputError } from "../InputError/InputError";
import {
  FormFieldProps,
  FormFieldString,
} from "../../commonTypes/formField.types";
import { hashCode } from "../../utils/hash";
export interface SelectBoxOption {
  uuid?: string | number;
  key: string;
  text: string;
  hidden?: boolean;
  count?: number;
}
export interface SelectBoxProps extends FormFieldProps<string> {
  options?: SelectBoxOption[];
  disableDefaultOption?: boolean;
  defaultOptionText?: string;
  className?: string;
  additionalAttributes?: HTMLAttributes<any>;
  labelClass?: string;
}

export interface SelectBoxState extends FormFieldString {
  selectedText: string;
  clicked: boolean;
}

const DEFAULT_STATE_VALUE = "";

export class SelectBox extends Component<SelectBoxProps, SelectBoxState> {
  static defaultProps = {
    value: "",
    options: [],
    fieldName: "",
    isTouched: false,
    errorMessage: "",
    defaultOptionText: "Välj en fil", // todo, change this to something else and set the value from callers.
    disabled: null,
    additionalAttributes: null,

    onChange: () => {},
  } as SelectBoxProps;

  private _id: string;
  private _errorId: string;
  private _latestValue: string | undefined;

  constructor(props: any) {
    super(props);
    this._id = props.id || hashCode(props.fieldName, "selectBox");
    this._errorId = hashCode(props.id || props.fieldName, "error");
    const { fieldName, isRequired, value } = this.props;

    if (props.value !== undefined) {
      this._latestValue = value;
    } else {
      this._latestValue = DEFAULT_STATE_VALUE;
    }
    this.state = {
      value: this._latestValue,
      fieldName,
      isTouched: false,
      errorMessage: "",
      isRequired,
      selectedText: "",
      clicked: false,
    };
  }

  private get _errorMessage(): string | undefined {
    let { errorMessage } = this.state;
    if (!errorMessage && this.props.errorMessage) {
      errorMessage = this.props.errorMessage;
    }

    return errorMessage;
  }

  onBlur = (e: React.FocusEvent<HTMLSelectElement>) => {
    this.setState({
      isTouched: true,
    });
  };

  onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { options } = this.props;
    e.preventDefault();
    const value = e.target.value;
    const currentOption = options.find((x) => x.key === e.target.value);

    this.setState(
      {
        value,
        isTouched: true,
        selectedText: currentOption ? currentOption.text : "",
      },
      () => {
        this.props.onChange(this.state);
      }
    );
  };

  private get _ariaAttributes(): HTMLAttributes<any> {
    const { errorAriaAttributes } = this.props;
    if (errorAriaAttributes) return errorAriaAttributes;
    if (this._errorMessage)
      return { "aria-invalid": true, "aria-describedby": this._errorId };
    return {};
  }
  toggleClicked = () => {
    this.setState((prevState) => ({
      clicked: !prevState.clicked,
    }));
  };

  public render() {
    const {
      fieldName,
      options,
      isRequired,
      label,
      labelClass,
      disableDefaultOption,
      defaultOptionText,
      className,
      disabled,
      additionalAttributes,
    } = this.props;
    const errorMessage = this._errorMessage;
    const { value } = this.state;
    const selectClassName = errorMessage ? "formelement-has-error" : "";
    return (
      <div
        className={`sos-selectbox ${
          this.state.clicked ? "clicked-selectbox" : "selectbox"
        } ${className || ""}`}
        onClick={this.toggleClicked}
      >
        {label && (
          <label className={labelClass} htmlFor={this._id}>
            {label}
          </label>
        )}
        <select
          className={selectClassName}
          id={this._id}
          onChange={this.onChange}
          name={fieldName}
          onBlur={this.onBlur}
          required={isRequired}
          value={value || ""}
          disabled={disabled}
          {...additionalAttributes}
          {...this._ariaAttributes}
        >
          {!disableDefaultOption && (
            <option value={""}>{defaultOptionText}</option>
          )}
          {options.map((o, i) => (
            <option
              value={o.key}
              key={o.uuid || o.key || o.text}
              className={o.hidden ? "d-none" : ""}
            >
              {o.text}
              {o.count != null ? `${" (" + o.count + ")"}` : ""}
            </option>
          ))}
        </select>
        {errorMessage && (
          <>
            <InputError id={this._errorId} errorText={errorMessage} />{" "}
          </>
        )}
      </div>
    );
  }
}
